import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=0890950c"
import script from "./company.ts?vue&type=script&lang=js&external"
export * from "./company.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports